module.exports = __webpack_public_path__ + "assets/img/map.6926a01d.jpg";